import { getQueryParam } from '@mi-front/core';

export const THUMBNAIL_BORDER_SIZE = 1;

export const THUMBNAIL_HEIGHT = getQueryParam('thumbnail_height')
  ? Number(getQueryParam('thumbnail_height'))
  : 115;

/** True when `?preview_thumb_loading=1` is set so the loading thumb can be reviewed without waiting. */
export function isPreviewThumbLoadingEnabled(): boolean {
  return getQueryParam('preview_thumb_loading') === '1';
}
